import React, { Component, Fragment } from 'react'
import cx from 'classnames'
import * as emailjs from 'emailjs-com'
import PropTypes from 'prop-types'

import Button from '../../site/Button/Button'
import ButtonLink from '../../site/Button/ButtonLink'
import Input from '../../site/InputFloatingLabel'
import Modal from '../../Modal'
import RDGateway from '../../../gateways/RDGateway'

import './RequestContact.scss'

const FIELDS = ['name', 'email', 'phone', 'erp', 'needs']

class RequestContactv2 extends Component {
    static propTypes = {
        className: PropTypes.string,
        color: PropTypes.string,
        radius: PropTypes.string,
    }

    static defaultProps = {
        radius: 'half-rounded',
    }

    constructor(props) {
        super(props)

        this.rdGateway = new RDGateway()
        this.state = this.getInitialState(props)
    }

    getInitialState(props) {
        const initialObject = {
            showDemoModal: false,
            showDemoForm: false,
            name: '',
            email: '',
            phone: '',
            erp: '',
            needs: '',
            typingTimeout: 0,
        }

        FIELDS.forEach(campo => {
            initialObject[`${campo}Error`] = false
            initialObject[`${campo}Typing`] = false
        })

        return initialObject
    }

    openDemoModal(e) {
        e.preventDefault()

        this.setState({
            showDemoModal: true,
            showDemoForm: true
        })
    }

    closeDemoModal() {
        this.setState({
            showDemoModal: false,
            showDemoForm: false
        })
    }

    handleChange(e) {
        let stateKey;
        const targetId = e.target.id;
        let value = e.target.value;

        if (targetId.includes('-field')) {
            stateKey = targetId.substring(0, targetId.indexOf('-field'));
        } else if (targetId === 'email') {
            stateKey = 'email';
        } else if (targetId === 'telephone') {
            stateKey = 'phone';
        } else {
            stateKey = targetId;
        }

        if(stateKey === 'phone') {
            value = this.phoneMask(value)
        }

        if (this.state.typingTimeout) {
            clearTimeout(this.state.typingTimeout)
        }

        this.setState({
            [stateKey]: value,
            [`${stateKey}Error`]: false,
            [`${stateKey}Typing`]: true,
            typingTimeout: setTimeout(() => {
                    if(stateKey === 'email' && this.validateEmail(this.state.email)) {
                    }
                }, 3000)
        })
    }

    validation() {
        const newState = {}

        const regexPhone = /^\([1-9]{2}\) [2-9][0-9]{3,4}\-[0-9]{4}$/
        FIELDS.forEach(campo => {
            newState[`${campo}Error`]= !this.state[campo]
            switch (campo) {
                case 'email': {
                    newState[`${campo}Error`] = !this.validateEmail(this.state[campo])
                    break
                }
                case 'phone' : {
                    newState[`${campo}Error`] = !regexPhone.test(this.state[campo])
                    break
                }
            }
        })
        this.setState(newState)
        const lista = Object.values(newState)
        return lista.every(value => (!value))
    }

    validateEmail(email) {
        const regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return regexEmail.test(email.toLowerCase())
    }

    phoneMask(value) {
        var cleanPhone = value ? value.replace(/\D/g, "") : '',
            numberLength = cleanPhone.length

        if(numberLength > 10) {
            cleanPhone = cleanPhone.slice(0, 7) + '-' + cleanPhone.slice(7)
        } else if(numberLength > 6 && numberLength < 11) {
            cleanPhone = cleanPhone.slice(0, 6) + '-' + cleanPhone.slice(6)
        }

        if(numberLength > 2) {
            cleanPhone = cleanPhone.slice(0, 2) + ') ' + cleanPhone.slice(2)
        }

        if(numberLength > 0) {
            cleanPhone = '(' + cleanPhone.slice(0)
        }

        return cleanPhone
    }

    submitForm(e) {
        e.preventDefault()
        if(this.validation()) {
            const data = {
                conversion_identifier: 'solicitou-contato-parceiro-marketplace',
                'cf_tipo_de_conversao': 'Solicitou contato de um parceiro no Marketplace',
                name: this.state.name,
                email: this.state.email,
                personal_phone: this.state.phone,
                cf_erp_utilizado: this.state.erp,
                cf_descricao_da_necessidade: this.state.needs || '',
                cf_carteira_clientes_canais: this.props.portifolioOwner || '',
                'cf_codigo_do_parceiro_meus_pedidos': this.props.partnerId,
                'cf_nome_do_parceiro_canais1': this.props.partnerName,

            }

            emailjs.send('amazon_ses', 'template_marketplace', {
                partnerEmail: this.props.partnerEmail,
                contactName: this.state.name,
                contactEmail: this.state.email,
                contactPhone: this.state.phone,
                contactErp: this.state.erp,
                contactNeeds: this.state.needs || '',
            }, 'user_FFC9ya35Vf3Im0waOm5He')

            this.rdGateway.sendToRDStation(data)

            this.setState({
                showDemoForm: false
            })

            setTimeout(() => {
                this.setState({
                    showDemoModal: false,
                    showDemoForm: true
                })
            }, 3000)
        }
    }

    getDemoModal() {
        return (
            <Modal callbackCloseModal={() => this.closeDemoModal()}>
                <div className={cx('new-form-wrapper', this.state.showDemoForm ? '' : 'hide')}>
                    <h4 className='form-heading'>Preencha o formulário abaixo e solicite um contato agora mesmo</h4>
                    <form action='.' method='POST' className='new-form' onSubmit={e => this.submitForm(e)}>

                        <Input id='name-field' value={this.state.name} onChange={e => this.handleChange(e)} error={this.state.nameError} autoFocus placeholder={'Nome'}/>

                        <Input id='email' value={this.state.email} onChange={e => this.handleChange(e)} error={this.state.emailError} placeholder={'E-mail'}/>

                        <Input id='telephone' value={this.state.phone} onChange={e => this.handleChange(e)} error={this.state.phoneError} maxLength="15" placeholder={'Telefone'}/>

                        <Input id='erp-field' value={this.state.erp} onChange={e => this.handleChange(e)} error={this.state.erpError} placeholder={'Qual ERP usa atualmente?'}/>

                        <label htmlFor='needs-field'>Descreva sua necessidade:</label>
                        <textarea id='needs-field' defaultValue={this.state.needs} onChange={e => this.handleChange(e)}></textarea>


                        <div className='submit-demo-modal'>
                            <Button type='submit' radius={this.props.radius} className={this.props.className}>SOLICITAR CONTATO</Button>
                        </div>
                    </form>
                </div>
                <div className={cx('container-form-confirm', !this.state.showDemoForm ? '' : 'hide')}>
                    <img className='success-icon' src='/images/success.png' alt='Solicitação enviada com sucesso!'/>
                    <p className='paragraph'>Sua solicitação foi enviada com sucesso!</p>
                </div>
            </Modal>
        )
    }

    render() {
        return (
            <Fragment>
                <ButtonLink
                    href='.'
                    className={cx(this.props.className, (this.props.color === '#FFFFFF') ? '#494a5e' : this.props.color && 'colored')}
                    onClick={e => this.openDemoModal(e)}
                    title='Solicite o contato de um dos nossos especialistas.'
                    radius={this.props.radius}
                    size={this.props.size}
                    style={this.props.style}
                    {...(this.props.color && {style: {color: this.props.color}})}
                >
                    {this.props.children || 'peça uma demonstração'}
                </ButtonLink>
                {this.state.showDemoModal && this.getDemoModal()}
            </Fragment>
        )
    }
}

export default RequestContactv2



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/marketplace/Modal/RequestContactv2.jsx